export default __webpack_public_path__ + "static/media/adImg2.5ebe84db.jpg";